import request from '@/utils/http';

/**
 * 查询所有的分类
 * @returns {Promise}
 */
export function findCategoryList() {
  return request('/mall/category/findCategoryList', {
    method: 'GET'
  });
}
